import { Link } from 'react-router-dom';

const services = [
  {
    id: 1,
    en: 'Call Center',
    title: 'コールセンター\n企画・運営・管理',
    desc: 'コールセンターの立ち上げから日常運営、品質管理まで一貫してサポート。お客様の声を大切にした顧客対応体制を構築します。',
    icon: 'ri-headphone-line',
  },
  {
    id: 2,
    en: 'Outsourcing',
    title: '業務委託\nサービス',
    desc: 'バックオフィス業務・データ入力・各種事務処理など、幅広い業務を受託。コア業務への集中をサポートします。',
    icon: 'ri-briefcase-line',
  },
  {
    id: 3,
    en: 'Customer Support',
    title: 'カスタマー\nサポート代行',
    desc: '電話・メール・チャットによる顧客対応を代行。専門スタッフが丁寧かつ迅速に対応し、顧客満足度向上に貢献します。',
    icon: 'ri-customer-service-2-line',
  },
  {
    id: 4,
    en: 'Consulting',
    title: '業務プロセス\nコンサルティング',
    desc: '業務フローの分析・改善提案から実行支援まで。現場に寄り添ったコンサルティングで、組織の生産性向上を実現します。',
    icon: 'ri-line-chart-line',
  },
];

export default function ServicesPreview() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-cormorant text-[#c9a84c] text-sm tracking-[0.4em] uppercase block mb-3">Services</span>
          <h2 className="font-serif-jp text-[#0f1628] text-3xl md:text-4xl tracking-wider font-medium mb-4">提供サービス</h2>
          <div className="flex items-center justify-center gap-3">
            <div className="w-12 h-px bg-[#c9a84c]/40"></div>
            <div className="w-1.5 h-1.5 bg-[#c9a84c] rotate-45"></div>
            <div className="w-12 h-px bg-[#c9a84c]/40"></div>
          </div>
          <p className="text-[#0f1628]/50 text-sm tracking-wide mt-6 font-sans">
            多様な業務委託ニーズに、確かな品質でお応えします
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((svc) => (
            <div
              key={svc.id}
              className="border border-[#0f1628]/10 p-8 bg-white transition-all duration-500"
            >
              {/* Icon */}
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className={`${svc.icon} text-2xl text-[#c9a84c]`}></i>
              </div>

              {/* EN label */}
              <span className="font-cormorant text-[#c9a84c]/60 text-xs tracking-[0.3em] uppercase block mb-2">
                {svc.en}
              </span>

              {/* Title */}
              <h3 className="font-serif-jp text-[#0f1628] text-lg tracking-wide font-medium mb-4 whitespace-pre-line leading-snug">
                {svc.title}
              </h3>

              {/* Divider */}
              <div className="w-8 h-px bg-[#c9a84c]/40 mb-4"></div>

              {/* Desc */}
              <p className="text-[#0f1628]/50 text-xs leading-relaxed font-sans">
                {svc.desc}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-3 border border-[#0f1628]/30 text-[#0f1628] px-10 py-3.5 text-xs tracking-widest font-sans hover:bg-[#0f1628] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            サービス一覧を見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
